import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';


type MsgType = "I" | "E" | "W"; 
export interface ToastMsg {
  msg: string | undefined;
  msgType?: MsgType;
  msgTitle?: string;
} 

@Injectable({
  providedIn: 'root'
})
export class ToastmsgService {
  private msg : ToastMsg = {msg : "",msgType : "I", msgTitle:""};
  msgSubs!: Subject<ToastMsg>;
  constructor() {
    this.msgSubs = new Subject<ToastMsg>();
  }

  setMsg(msg: ToastMsg) {
    if (!msg.msgType) {
      msg.msgType = "I";
    }
    if (!msg.msgTitle) {
      msg.msgTitle = "Information";
    }
    this.msg = msg;
    this.msgSubs.next(msg);
  }

  getMsgSubs() {
    return this.msgSubs.asObservable();
  }
}
